import React from 'react';
import { ButtonPill } from '../Buttons/ButtonPill';
import { THandleButtonClick } from './utils/types';
import styles from './Calculator.module.css';

type TCalculatorButtonProps = {
    isEnabled: boolean;
    label: string;
    handleClick: THandleButtonClick;
};
const CalculatorButton = React.memo(({ isEnabled, label, handleClick }: TCalculatorButtonProps) => {
    return (
        <div className={styles.calculatorButtonStyled}>
            <ButtonPill
                hierarchy="primary"
                position="floating"
                isWidget={false}
                label={label ?? ''}
                handleClick={handleClick}
                isEnabled={isEnabled}
                maxWidth="100%"
            />
        </div>
    );
});
export { CalculatorButton };
